<template>
    <div class="about-view" v-loading="loading">
        <div class="row">
            <div class="col-md-12">
                <el-form ref="bannerImage" :model="page.form" :rules="page.formRules" label-width="150px">

                        <div class="row">
                            <div class="col-md-6">
                                <el-form-item label="Home Banner Image" prop="home">
                                    <div class="uploadDrag">
                                        <input
                                            type="file"
                                            id="fileUpload"
                                            ref="home"
                                            name="file"
                                            class="c-input u-sb-small"
                                            @change="handleChange('home')">
                                        <p id="fileUploadText">{{page.form.home.fileSelect}}</p>
                                    </div>
                                </el-form-item>
                            </div>

                            <div class="col-md-6 img-select" v-if="page.form.home.fileData != null">
                                <img :src="page.form.home.fileData" class="selected-img">
                            </div>

                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <el-form-item label="About Banner Image" prop="about">
                                    <div class="uploadDrag">
                                        <input
                                            type="file"
                                            id="fileUpload"
                                            ref="about"
                                            name="file"
                                            class="c-input u-sb-small"
                                            @change="handleChange('about')">
                                        <p id="fileUploadText">{{page.form.about.fileSelect}}</p>
                                    </div>
                                </el-form-item>
                            </div>

                            <div class="col-md-6 img-select" v-if="page.form.about.fileData != null">
                                <img :src="page.form.about.fileData" class="selected-img">
                            </div>

                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <el-form-item label="Course Banner Image" prop="course">
                                    <div class="uploadDrag">
                                        <input
                                            type="file"
                                            id="fileUpload"
                                            ref="course"
                                            name="file"
                                            class="c-input u-sb-small"
                                            @change="handleChange('course')">
                                        <p id="fileUploadText">{{page.form.course.fileSelect}}</p>
                                    </div>
                                </el-form-item>
                            </div>

                            <div class="col-md-6 img-select" v-if="page.form.course.fileData != null">
                                <img :src="page.form.course.fileData" class="selected-img">
                            </div>

                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <el-form-item label="Online Application Banner Image" prop="online_application">
                                    <div class="uploadDrag">
                                        <input
                                            type="file"
                                            id="fileUpload"
                                            ref="online_application"
                                            name="file"
                                            class="c-input u-sb-small"
                                            @change="handleChange('online_application')">
                                        <p id="fileUploadText">{{page.form.online_application.fileSelect}}</p>
                                    </div>
                                </el-form-item>
                            </div>

                            <div class="col-md-6 img-select" v-if="page.form.online_application.fileData != null">
                                <img :src="page.form.online_application.fileData" class="selected-img">
                            </div>

                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <el-form-item label="Contact Banner Image" prop="contact">
                                    <div class="uploadDrag">
                                        <input
                                            type="file"
                                            id="fileUpload"
                                            ref="contact"
                                            name="file"
                                            class="c-input u-sb-small"
                                            @change="handleChange('contact')">
                                        <p id="fileUploadText">{{page.form.contact.fileSelect}}</p>
                                    </div>
                                </el-form-item>
                            </div>

                            <div class="col-md-6 img-select" v-if="page.form.contact.fileData != null">
                                <img :src="page.form.contact.fileData" class="selected-img">
                            </div>

                        </div>
                    
                     <el-form-item>
                        <el-button :loading="page.updateBtnLoad" @click="setData" type="primary">Update</el-button>
                    </el-form-item>
                    
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
import {generateHeader, handleFileType, handleFileSize} from "@/misc/function.js";
import { VueEditor } from "vue2-editor";
export default {
    components: {
        VueEditor
    },
    data () {
        const validImg = (rule, value, callback) => {
            if(Array.isArray(value.img)){
                value = value.img.name
            }
            else{
                value = value.img
            }

            if (!value) {
                callback(new Error('Please Select File'))
            } else {
                callback()
            }
        } 
        return {
            loading: false,
            rights: {
                page: true,
            },
            page: {
                updateBtnLoad: false,
                formValid: false,
                form: {
                    length: 5,
                    home: {
                        bi_id: 0,
                        img: '',
                        fileSelect: 'Drag your files here or click in this area.',
                        fileData: null,
                        fileError: false,
                    },
                    about: {
                        bi_id: 0,
                        img: '',
                        fileSelect: 'Drag your files here or click in this area.',
                        fileData: null,
                        fileError: false,
                    },
                    course: {
                        bi_id: 0,
                        img: '',
                        fileSelect: 'Drag your files here or click in this area.',
                        fileData: null,
                        fileError: false,
                    },
                    online_application: {
                        bi_id: 0,
                        img: '',
                        fileSelect: 'Drag your files here or click in this area.',
                        fileData: null,
                        fileError: false,
                    },
                    contact: {
                        bi_id: 0,
                        img: '',
                        fileSelect: 'Drag your files here or click in this area.',
                        fileData: null,
                        fileError: false,
                    }
                },
                formRules: {
                    home: [{ required: true, trigger: 'blur', validator: validImg }],
                    about: [{ required: true, trigger: 'blur', validator: validImg }],
                    course: [{ required: true, trigger: 'blur', validator: validImg }],
                    online_application: [{ required: true, trigger: 'blur', validator: validImg }],
                    contact: [{ required: true, trigger: 'blur', validator: validImg }]
                }
            }
        }
    },
    methods: {
        init(){
            // this.getRights()
            this.getData()
        },
        //
        handleRemove(ref_id){
            this.page.form[ref_id].img = ''
            this.page.form[ref_id].fileSelect = 'Drag your files here or click in this area.'
            this.page.form[ref_id].fileData = null
            this.page.form[ref_id].fileError = false
        },
        handleChange(ref_id) {
            this.page.form[ref_id].img = this.$refs[ref_id].files[0]
            if(handleFileSize(1393750 , this.page.form[ref_id].img.size) == "false"){
                this.page.form[ref_id].fileError = true
                this.$notify.info({
                    title: 'Info',
                    message: "File Size Too Large. Please Upload less then 1MB File !!!"
                });
            }
            var allowed_type = ['image/png' , 'image/jpg' , 'image/jpeg']
            if(handleFileType(allowed_type , this.page.form[ref_id].img.type) == "false"){
                this.page.form[ref_id].fileError = true
                this.$notify.info({
                    title: 'Info',
                    message: "File Type Invalid. Please Upload Only png , jpg or jpeg type !!!"
                });
            }
            
            if(!this.page.form[ref_id].fileError){

                this.page.form[ref_id].fileSelect = "File Selected"
                const input = this.$refs[ref_id]
                const files = input.files
                if (files && files[0]) {
                    const reader = new FileReader
                    reader.onload = e => {
                    this.page.form[ref_id].fileData = e.target.result
                    }
                    reader.readAsDataURL(files[0])
                    this.$emit('input', files[0])
                }
            }
            else{
                this.page.form[ref_id].img = ""
                this.page.form[ref_id].fileError = false
            }
        },
        handleFormValid(formRef){
            this.$refs[formRef].validate((valid) => {
                if(valid){
                    this.page.formValid = true

                    if( this.page.form.home.img == "" || 
                        this.page.form.about.img == "" || 
                        this.page.form.course.img == "" || 
                        this.page.form.online_application.img == "" || 
                        this.page.form.contact.img == "")
                    {
                        this.page.formValid = false
                    }
                }
                else{
                    this.page.formValid = false
                }
            });
        },
            // getRights() {
            //     this.loading = true
            //     this.$axios.post('about/rights.php' , {} , {
            //         headers: generateHeader("aboutRights")
            //     })
            //     .then((response) => {
            //         if(response.data.code == "200"){
            //             //Whole Page Right
            //             this.rights.page = response.data.body.rights.about_page == 1 ? true : false
            //             if(this.rights.page){
            //                 this.getData();
            //             }
            //         }
            //         else if(response.data.code == "403"){
            //             this.$notify.info({
            //                 title: 'Info',
            //                 message: response.data.extra.message
            //             });
            //             this.$router.push('/admin/dashboard')
            //         }
            //         else if (response.data.code == "401"){
            //             this.$notify.info({
            //                 title: 'Info',
            //                 message: response.data.extra.message
            //             });
            //             localStorage.clear()
            //             this.$router.push('/login')
            //         }
            //         else{
            //             this.$notify.info({
            //                 title: 'Info',
            //                 message: response.data.extra.message
            //             });
            //         }
            //         this.loading = false
            //     })
            //     .catch((error) => {
            //         this.$notify.error({
            //             title: 'Error',
            //             message: error
            //         });
            //         this.loading = false
            //     })
            // },
        getData() {
            this.loading = true
            this.$axios.post("banner-images/get.php" , {}, {
                headers: generateHeader("getImageData")
            })
            .then((response) => {
                if(response.data.code == "200"){
                    for(var i=0; i< response.data.body.length; i++){
                        var body = response.data.body[i]
                        var arrVal = body.page

                        var arr = this.page.form[arrVal]
                        arr.bi_id = body.bi_id
                        if(body.image_path != ""){
                            arr.img = body.image
                            arr.fileSelect = 'File Selected'
                            arr.fileData = body.image_path
                        }
                        else{
                            arr.img = ""
                            arr.fileSelect = 'Drag your files here or click in this area.'
                            arr.fileData = null
                        }
                    }
                }
                else if(response.data.code == "404"){
                    for(var i=0; i< this.page.form.length; i++){
                        var arr = this.page.form[i]
                        arr.bi_id = 0
                        arr.img = ""
                        arr.fileSelect = 'Drag your files here or click in this area.'
                        arr.fileData = null
                    }
                }
                else if (response.data.code == "401"){
                    this.$notify.info({
                        title: 'Info',
                        message: response.data.extra.message
                    });
                    localStorage.clear()
                    this.$router.push('/login')
                }
                else{
                    this.$notify.info({
                        title: 'Info',
                        message: response.data.extra.message
                    });
                }
                this.loading = false
            })
            .catch((error) => {
                this.$notify.error({
                    title: 'Error',
                    message: error                       
                });
                this.loading = false
            })
        },
        setData() {
            this.handleFormValid("bannerImage")
            if(this.page.formValid){

                this.page.updateBtnLoad = true
                
                let formData = new FormData()
                formData.append('home', this.page.form.home.img)
                formData.append('about', this.page.form.about.img)
                formData.append('course', this.page.form.course.img)
                formData.append('online_application', this.page.form.online_application.img)
                formData.append('contact', this.page.form.contact.img)

                
                this.$axios.post("banner-images/set.php" ,formData, {
                    headers: generateHeader("setBannerData" , true)
                })
                .then((response) => {
                    if(response.data.code == "204"){
                        this.$notify.success({
                            title: 'Success',
                            message: response.data.extra.message
                        });
                        // this.getData()
                    }
                    else if(response.data.code == "412"){
                        this.$notify.info({
                            title: 'Info',
                            message: response.data.extra.message
                        });
                    }
                    else if (response.data.code == "401"){
                        this.$notify.info({
                            title: 'Info',
                            message: response.data.extra.message
                        });
                        localStorage.clear()
                        this.$router.push('/login')
                    }
                    else{
                        this.$notify.info({
                            title: 'Info',
                            message: response.data.extra.message
                        });
                    }
                    this.page.updateBtnLoad = false
                })
                .catch((error) => {
                    this.$notify.error({
                        title: 'Error',
                        message: error                       
                    });
                    this.page.updateBtnLoad = false
                })
            }
        }
    },
    mounted() {
        this.init()
    }
}
</script>

<style>
    .uploadDrag{
        /* position: absolute; */
        width: 100%;
        height: 200px;
        border: 4px dashed #000;
    }
    #fileUpload{
        position: absolute;
        margin: 0;
        padding: 0;
        width: 100%;
        height: 100%;
        outline: none;
        opacity: 0;
    }
    #fileUploadText{
        width: 100%;
        height: 100%;
        text-align: center;
        line-height: 170px;
        color: #000;
        font-family: Arial;
    }

    .selected-img{
        height: 200px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        text-align: center;
    }

    .middle {
        /* transition: .5s ease; */
        opacity: 0;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        text-align: center;

        background: #000;
        padding: 10px;
        color: #fff;
        border-radius: 5px;
        cursor: pointer;
    }

    .img-select:hover .selected-img{
        opacity: 1;
    }

    /* .img-select:hover .middle{
        opacity: 1;
    } */
</style>